import type { Editor } from '@tiptap/core';

import type { PmConverters } from './../../pm-converters/collect';
import type { Decoration } from './../../ricos-schema/legacy/wix/rich_content/v1';

export class EditorStateQuery {
  // eslint-disable-next-line no-useless-constructor
  constructor(private editor: Editor, private converters: PmConverters) {}

  storedDecorations(): Decoration[] | null {
    if (this.editor.state.storedMarks === null) {
      return null;
    }
    return this.converters.marksToDecorations(this.editor.state.storedMarks.map(m => m.toJSON()));
  }
}
